import 'swiper/dist/css/swiper.css'
import recomendacionesImage from 'assets/img/muestra/recomendaciones.jpg'
import arrowBack from 'assets/img/svg/arrow-back.svg'
import arrowNext from 'assets/img/svg/arrow-next.svg'

export default {
  name: 'home-product-viewer',
  props: ['data'],
  computed: {
    dataParsed: function () {
      return JSON.parse(this.data)
    },

    productList: function () {
      var productList = this.dataParsed.productList
      var finalList = []
      _.each(productList, function (product) {
        product.image = _.find(product.images, function (image) {
          return image.format === 'product'
        })
        finalList.push(product)
      })
      return finalList
    },

    title: function () {
      return this.dataParsed.title
    }
  },

  data () {
    var min=0;
    var max=100; 
    this.id1 = Math.floor(Math.random() * (+max + 1 - +min)) + +min;
    this.idPrev = 'prev_' + this.id1
    this.idNext = 'next_' + this.id1

    return {
      recomendacionesImage: recomendacionesImage,
      arrowBack: arrowBack,
      arrowNext: arrowNext,
      swiperOption: {
        preloadImages: false,
        lazy: true,

        slidesPerView: 5,
        spaceBetween: 25,
        breakpoints: {
          767: {
            slidesPerView: 2,
            spaceBetween: 20
          },

          1023: {
            slidesPerView: 3,
            spaceBetween: 20
          }
        },

        navigation: {
          nextEl: '#next_' + this.id1,
          prevEl: '#prev_' + this.id1
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/homeproductviewer/homeproductviewer.js